import { render, staticRenderFns } from "./amfyTable.vue?vue&type=template&id=a7fd9ac2&scoped=true"
import script from "./amfyTable.vue?vue&type=script&lang=ts"
export * from "./amfyTable.vue?vue&type=script&lang=ts"
import style0 from "./amfyTable.vue?vue&type=style&index=0&id=a7fd9ac2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fd9ac2",
  null
  
)

export default component.exports